'use client';
import Login from "./login/page";
export default function App(): JSX.Element {
  return (
    <Login />
  );
}
